<template>
  <div>
    <!-- 弹出层 -->
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="show-tip">
          <i class="iconfont" @click="close" v-if="data.hasOwnProperty('hasCloseBtn') ? data.hasCloseBtn : true">&#xe61e;</i>
          <div class="tip-title">{{data.title}}</div>
          <hr>
          <div class="word" v-html="data.content"></div>
          <div class="btns">
            <div class="btn cancel" @click="close">否</div>
            <div class="btn confirm" @click="confirm">是</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm', this)
    },
    close () {
      this.$emit('close', this)
    }
  },
  mounted () {
  }
}
</script>
<style lang="sass" scoped>
@import '../../style/bulma/app.sass'

.modal
  .modal-content
    width: 1000px
    display: flex
    justify-content: center
    margin-top: -80px
  &.is-active
    z-index: 101
  .modal-background
    background-color: rgba(10, 10, 10, 0.4)
    video
      width: 100%
      height: 100%

// 提示窗相关
.show-tip22
  width: 350px
  height: 170px
  background-color: #fff
  border-radius: 5px
  overflow: hidden
  display: flex
  flex-direction: column
  align-items: center
  .wrapper
    flex-grow: 1
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
    padding: 25px
    .word
      font-size: 18px
      text-align: center
.show-tip
  background: #fff
  width: 358px
  // height: 256px
  border-radius: 5px
  padding: 30px 42px
  position: relative
  i
    position: absolute
    right: 16px
    top: 7px
    font-size: 21px
    color: #888
    cursor: pointer
  .tip-title
    text-align: center
    font-weight: 700
    font-size: 18px
    margin-bottom: 15px
    color: $primary3
  hr
  .img
    position: relative
    margin: 0 auto
    width: 132px
    height: 132*1.17px
    border: 1px solid $primary3
    overflow: hidden
    img
      position: absolute
      width: 100%
  .word
    color: #666
    font-size: 14px
    text-align: center
    ::v-deep h3
      font-weight: 700
      line-height: 2
    ::v-deep p
      line-height: 2
  .btns
    display: flex
    justify-content: space-between
    margin-top: 24px
    .btn
      font-size: 14px
      text-align: center
      border: 1px solid $primary3
      border-radius: 2px
      width: 125px
      padding: 6px 10px
      &.confirm
        color: #fff
        background-color: $primary3
        cursor: pointer
      &.cancel
        margin-right: 15px
        color: $primary3
        cursor: pointer
</style>
